import axios from 'axios'
import { NRLogger } from '../../modules/logging/nrLogging'
import trim from 'validator/es/lib/trim'
import { formatLocale } from '../../utils/general.utils'

export default class WebToCaseService {
  async submit(emailParams, config, authorizationHeader) {
    try {
      const data = this.formCaseData(emailParams)

      const url = `${config.hccService}/v1/case/origins/email`
      const result = await axios({
        method: 'post',
        url,
        data,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-recap-token': emailParams.recaptchaResponse,
          Authorization: authorizationHeader,
        },
      })
        .then((response) => {
          // handle success

          NRLogger.info('UBIK Help Center - Create Email Case', {
            tenant: emailParams.tenant,
            locale: emailParams.locale,
            url,
            status: response.status,
          })

          return response.data
        })
        .catch((error) => {
          NRLogger.error('UBIK Help Center - Create Email Case', {
            tenant: emailParams.tenant,
            locale: emailParams.locale,
            url,
            status: error.response?.status,
            message: 'Error occurred while submitting email case',
            stack: JSON.stringify(error),
            ...emailParams,
          })
          return false
        })

      return result
    } catch (exception) {
      console.error('exception ', exception)
      return false
    }
  }

  formCaseData(emailParams) {
    const subject = emailParams.subjects.filter((obj) => {
      return obj.id === emailParams.subject.value
    })

    return {
      email: trim(emailParams.email.value),
      firstName: trim(emailParams.firstName.value),
      lastName: trim(emailParams.lastName.value),
      subject: subject[0].value + ' - ' + emailParams.valueIssue.value,
      comment: trim(emailParams.comment.value),
      companyName: emailParams.company.value !== undefined ? trim(emailParams.company.value) : '',
      tenant: emailParams.tenant,
      locale: formatLocale(emailParams.locale),
      orderNumber: emailParams.orderNumber !== undefined && emailParams.orderNumber.value !== undefined ? trim(emailParams.orderNumber.value) : '',
      phoneNumber: emailParams.phoneNumber !== undefined && emailParams.phoneNumber.value !== undefined ? trim(emailParams.phoneNumber.value) : '',
      assets: emailParams.uploadedFiles,
    }
  }
}
